import { render, staticRenderFns } from "./suggestionsListViewer.vue.html?vue&type=template&id=4d9349e8&"
import script from "./suggestionsListViewer.ts?vue&type=script&lang=ts&"
export * from "./suggestionsListViewer.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports